module.exports = __webpack_public_path__ + "img/brm5.2302c00a.jpg";